import { render, staticRenderFns } from "./openGzh.vue?vue&type=template&id=3a3e33b1&scoped=true"
import script from "./openGzh.vue?vue&type=script&lang=js"
export * from "./openGzh.vue?vue&type=script&lang=js"
import style0 from "./openGzh.vue?vue&type=style&index=0&id=3a3e33b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e33b1",
  null
  
)

export default component.exports